import React from 'react'
import * as bs4 from 'reactstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
// import Select from 'react-dropdown-select';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Navbar from '../Navbar'
import { ScaleLoader } from 'react-spinners';
const { proxy } = require('../../ip_api.config')

class Acc_EditBomLine extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            id: '',
            isLoading: false,
            arr_item: [],
            arr_check: [],
            arr_show: [],
            arr_save: [],
            arr_additem: []
        }
    }

    componentDidMount() {
        if (localStorage.getItem("ID_User") !== null) {
            this.setState({
                id: this.props.location.state.id_edit
            }, () => {
                console.log('id', this.state.id)
                this.getItem(this.state.db_name, 0)
            })
        } else {
            this.props.history.push({
                pathname: '/'
            })
        }
    }

    getItem = (db_name, _value) => {
        this.setState({ isLoading: true })

        let arr = []
        let url = proxy.server + '/acc/get_item'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                db_name: db_name,
                value: _value
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arr.push({ value: val.NAMEALIAS, label: val.ITEMID })
                })
                this.setState({ option: arr, isLoading: false }, () => {
                    this.push_arrBomSave()
                })
            })
    }

    push_arrBomSave = () => {
        this.setState({ isLoading: true })
        let arr = []
        let temp
        let last
        let url = proxy.server + '/acc/get_bomline'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: this.state.id
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    let data = {
                        id: val.id,
                        db_name: val.db_name,
                        user: val.BOM_ApproverPersonnelNumber,
                        bom_no: val.BOM_BOMId,
                        bom_description: val.BOM_Name,
                        type: val.BOM_BOMId.charAt(0),
                        item_group: val.BOM_ItemGroupId,
                        line_no: val.LineNum,
                        item_no: val.ItemId,
                        amount: val.BOMQty,
                        unit: val.UnitId,
                    }

                    arr.push(data)
                    last = val.LineNum
                })
                temp = this.state.arr_save.concat(arr)
                this.setState({
                    last: last, arr_save: temp, responseJson: arr,
                    itemno: responseJson.result[0].BOM_BOMId,
                    description: responseJson.result[0].BOM_Name,
                    db_name: responseJson.result[0].db_name
                }, () => { this.getBom_Preview() })
            })
    }

    getBom_Preview = () => {
        let arr = []

        this.state.responseJson.map(function (val, i) {
            arr.push(
                <tr>
                    <td><bs4.Button color="danger" size='sm' onClick={() => this.onDeleteBom(val.id)}>X</bs4.Button></td>
                    {
                        val.db_name === 'DPL' ?
                            <td style={{ backgroundColor: '#00BFFF', color: '#000' }}>{val.db_name}</td>
                            : val.db_name === 'DFIX' ?
                                <td style={{ backgroundColor: '#00FA9A', color: '#000' }}>{val.db_name}</td>
                                : val.db_name === 'DPT' ?
                                    <td style={{ backgroundColor: '#fec23e', color: '#000' }}>{val.db_name}</td>
                                    : <td></td>
                    }
                    <td>{val.user}</td>
                    {/* <td><bs4.Col sm='12'>
                        <bs4.Input type="text" name="bom_no" onBlur={(e) => e.target.value.length > 20 ? alert('ห้ามกรอกเกิน 20 ตัวอักษร') : this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.bom_no} />
                    </bs4.Col></td>
                    <td><bs4.Col sm='12'>
                        <bs4.Input type="textarea" name="bom_description" onBlur={(e) => e.target.value.length > 50 ? alert('ห้ามกรอกเกิน 20 ตัวอักษร') :  this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.bom_description} />
                    </bs4.Col></td>
                    <td>{this.state.arr_save[i].type}</td>
                    <td>{this.state.arr_save[i].item_group}</td>
                    <td>{this.state.arr_save[i].line_no}</td> */}
                    <td><bs4.Col sm='12'>
                        <bs4.Input type="text" name="item_no" onBlur={(e) => e.target.value.length > 20 ? alert('ห้ามกรอกเกิน 20 ตัวอักษร') : this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.item_no} />
                    </bs4.Col></td>
                    <td><bs4.Col sm='12'>
                        <bs4.Input type="text" name="amount" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.amount} />
                    </bs4.Col></td>
                    <td>{val.unit}</td>
                </tr>
            )
        }, this)
        this.setState({ previewbom: arr, isLoading: false })
    }

    handleChangeItem = (index, name, value) => {
        if (name === 'bom_no') {
            this.state.arr_save[index].bom_no = value

            let type = value.charAt(0)
            this.state.arr_save[index].type = type

            let item_group = type === 'G' ? 'FG' : type === 'H' ? 'HP' : type === 'S' ? 'SM' : type === 'P' ? 'PK' : type === 'S' ? 'SU' : '0'
            this.state.arr_save[index].item_group = item_group

        } else if (name === 'bom_description') {
            this.state.arr_save[index].bom_description = value
        } else if (name === 'item_no') {
            this.state.arr_save[index].item_no = value
        } else if (name === 'amount') {
            this.state.arr_save[index].amount = value
        }

        this.setState({
            arr_save: this.state.arr_save
        }, () => {
            console.log('arr_save', this.state.arr_save)
            this.getBom_Preview()
        })
    }

    handleChangeItemAutocomplete = (event, values, index) => {
        console.log('index', index)
        console.log('values', values)
        if (values === null || values === 'null') {
            let _item = ""
            this.state.arr_save[index].item_no = ""
            // this.state.arr_save[index].item_description = ""

            this.setState({
                item_name: _item,
                arr_save: this.state.arr_save,
                selectedOption: ""
            }, () => {
                console.log('arr_save', this.state.arr_save)
                this.getBom_Preview()
            })
        } else {
            let _item = values.label
            this.state.arr_save[index].item_no = values.label
            // this.state.arr_save[index].item_description = values.value

            this.setState({
                item_name: _item,
                arr_save: this.state.arr_save,
                selectedOption: values.label
            }, () => {
                console.log('arr_save', this.state.arr_save)
                this.getBom_Preview()
            })
        }
    }

    update_bomline = () => {
        if (window.confirm("กรุณายืนยันการบันทึก")) {
            this.setState({ isLoading: true })
            let url = proxy.server + '/acc/update_bomline'
            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8"
                },
                body: JSON.stringify({
                    id: this.state.id,
                    arr: this.state.arr_save
                })
            })
                .then(response => response.json())
                .then((responseJson) => {
                    console.log("responseJson", responseJson)
                    if (responseJson.status === 201) {
                        this.setState({ isLoading: false }, () => {
                            this.push_arrBomSave()
                        })
                    } else {
                        this.setState({ isLoading: false }, () => {
                            alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                        })
                    }
                })
        }
    }

    addItem = () => {
        const { arr_additem, db_name, last, itemno, description } = this.state
        console.log('last', this.state.last)
        let temp

        let data = {
            db_name: db_name,
            user: localStorage.getItem("ID_User"),
            bom_no: itemno,
            bom_description: description,
            type: '',
            item_group: '',
            Lineno: parseInt(last) + 1,
            item_no: '',
            item_description: '',
            amount: '',
            unit: 'PCS'
        }

        temp = arr_additem.concat(data)

        this.setState({
            arr_additem: temp,
            last: parseInt(this.state.last) + 1
        }, () => {
            console.log('arr_additem', this.state.arr_additem)
            this.showItem(1)
        })
    }

    showItem = (num) => {
        console.log('last', this.state.last)

        let arr = []
        this.state.arr_additem.forEach(function (val, i) {
            let type = val.bom_no.charAt(0)
            let item_group = type === 'G' ? 'FG' : type === 'H' ? 'HP' : type === 'S' ? 'SM' : type === 'P' ? 'PK' : type === 'S' ? 'SU' : '0'
            arr.push(
                <tr style={{ backgroundColor: '#FAFAD2' }}>
                    <td><bs4.Button color="danger" size='sm' onClick={() => this.onDeleteTemp(i)}>X</bs4.Button></td>
                    {
                        val.db_name === 'DPL' ?
                            <td style={{ backgroundColor: '#00BFFF', color: '#000' }}>{val.db_name}</td>
                            : val.db_name === 'DFIX' ?
                                <td style={{ backgroundColor: '#00FA9A', color: '#000' }}>{val.db_name}</td>
                                : val.db_name === 'DPT' ?
                                    <td style={{ backgroundColor: '#fec23e', color: '#000' }}>{val.db_name}</td>
                                    : <td></td>
                    }
                    <td>{val.user}</td>
                    <td>
                        {/* <bs4.Col sm='12'> */}
                        {/* <Select className="col-md-12"
                            onChange={(e) => this.handleChangeItemSave(i, 'item_no', e)}
                            options={this.state.option}
                            placeholder={'ค้นหา Item'}
                        /> */}
                        <Autocomplete
                            id="combo-box-demo"
                            options={this.state.option}
                            getOptionLabel={(option) => option.label}
                            // onChange={(e) => this.setState({ selectedOption: e }, () => this.handleChangeItem(i, 'item_no', e))}
                            // onInputChange={this.setState({ index : i })}
                            onChange={(event, values) => this.handleChangeItemAutocomplete(event, values, i)}
                            size={'small'}
                            renderInput={(params) => <TextField {...params} label={val.item_no} variant="outlined" onChange={(e) => this.getItem(this.state.db_name, e.target.value)} />}
                        />
                        {/* </bs4.Col> */}
                    </td>
                    <td>
                        <bs4.Col sm='12'>
                            <bs4.Input type="text" name="amount" onChange={(e) => this.handleChangeItemSave(i, e.target.name, e.target.value)} />
                        </bs4.Col>
                    </td>
                    <td>{val.unit}</td>
                </tr>
            )

            if (num !== 0) {

                this.state.arr_additem[i].type = type
                this.state.arr_additem[i].item_group = item_group
            }

        }, this)

        this.setState({
            showBomLine: arr,
            arr_additem: this.state.arr_additem,
            // last: last
        })
    }

    handleChangeItemSave = (index, name, _value) => {
        if (name === 'item_no') {
            let value = _value[0].value
            let item_temp = value.split('$')
            this.state.arr_additem[index].item_no = item_temp[0]
            this.state.arr_additem[index].item_description = item_temp[1]
        } else if (name === 'amount') {
            this.state.arr_additem[index].amount = _value
        }

        this.setState({
            arr_additem: this.state.arr_additem
        }, () => {
            console.log('arr_additem', this.state.arr_additem)
        })
    }

    saveItem = () => {
        let space = 0
        this.state.arr_save.map(function (val, i) {
            if (val.item_no === '' || val.amount === '') {
                space++
            }
        })

        if (space > 0) {
            alert('กรุณากรอกข้อมูลให้ครบ')
        } else {
            if (window.confirm("กรุณายืนยันการบันทึก")) {
                this.setState({ isLoading: true })
                let url = proxy.server + '/acc/insert_bomLine'
                fetch(url, {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json;charset=utf-8"
                    },
                    body: JSON.stringify({
                        arr: this.state.arr_additem,
                        id: this.state.id
                    })
                })
                    .then(response => response.json())
                    .then((responseJson) => {
                        console.log("responseJson", responseJson)
                        if (responseJson.status === 201) {
                            this.setState({
                                showBomLine: '',
                                arr_show: [],
                                arr_additem: [],
                                isLoading: false
                            }, () => {
                                this.push_arrBomSave()
                            })
                        } else {
                            alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                        }
                    })
            }
        }
    }

    onDeleteTemp = (index) => {
        this.state.arr_additem.splice(index, 1)
        // this.state.arr_save.splice(index, 1)
        this.setState({
            arr_additem: this.state.arr_additem,
            // arr_save: this.state.arr_save,
        }, () => {
            console.log('arr_additem', this.state.arr_additem)
            this.showItem(0)
        })
    }

    onDeleteBom = (id) => {
        if (window.confirm("กรุณายืนยันการลบ")) {
            this.setState({ isLoading: true })
            let url = proxy.server + '/acc/delete_bomline'
            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8"
                },
                body: JSON.stringify({
                    id: id,
                })
            })
                .then(response => response.json())
                .then((responseJson) => {
                    console.log("responseJson", responseJson)
                    if (responseJson.status === 201) {
                        this.setState({ isLoading: false }, () => {
                            alert('ลบสำเร็จ')
                            this.push_arrBomSave()
                        })
                    } else {
                        this.setState({ isLoading: false }, () => {
                            alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                        })
                    }
                })
        }
    }

    render() {
        return <div>
            <Navbar nav={'Acc'} menu={'Acc_EditBomLine'} />
            <div style={{ marginLeft: 20, marginTop: 50, marginRight: 10 }}>
                <bs4.FormGroup row style={{ marginLeft: 10, marginBottom: 20 }}>
                    <bs4.Label style={{ fontSize: 20, fontWeight: 500, marginRight: 20 }} >EDIT BOM LINE</bs4.Label>
                    {
                        this.state.arr_additem.length === 0
                            ? <bs4.Button color="warning" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.update_bomline()}>SAVE</bs4.Button>
                            : <bs4.Button outline color="warning" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.saveItem()}>SAVE</bs4.Button>

                    }
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                </bs4.FormGroup>
                <bs4.FormGroup row>
                    <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>Item No</bs4.Label>
                    <bs4.Col sm='4'>
                        <bs4.Input value={this.state.itemno} disabled />
                    </bs4.Col>
                    <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>Description</bs4.Label>
                    <bs4.Col sm='4'>
                        <bs4.Input value={this.state.description} disabled />
                    </bs4.Col>
                    <bs4.Button style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.addItem()}>+ ADD</bs4.Button>
                </bs4.FormGroup>
                <br />
                <bs4.Table bordered hover>
                    <thead style={{ backgroundColor: '#8f8f8f', color: '#000' }}>
                        <tr style={{ textAlign: 'center' }}>
                            <th></th>
                            <th>ฐานข้อมูล</th>
                            <th>รหัสพนักงาน</th>
                            {/* <th>Bom No.</th>
                            <th>bom_description</th>
                            <th>Type</th>
                            <th>Item Group</th>
                            <th>Line No</th> */}
                            <th style={{ backgroundColor: '#fec23e', color: '#000' }}>Item No.</th>
                            <th style={{ backgroundColor: '#fec23e', color: '#000' }}>จำนวน</th>
                            <th>หน่วยของสินค้า</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.previewbom}
                        {this.state.showBomLine}
                    </tbody>
                </bs4.Table>
            </div>
        </div>
    }
}

export default Acc_EditBomLine